import styled from "@emotion/styled";
import React, { ReactElement, useLayoutEffect, useMemo, useRef, useState } from "react";
import ReactDOM from "react-dom";

export const PortalMenu: React.FC<{
    anchorEl: HTMLElement | null;
    children: React.ReactNode;
    /** open above the control */
    openAbove?: boolean;
    zIndex?: number;
    matchWidth?: boolean;
}> = ({ anchorEl, children, openAbove = true, zIndex = 99999, matchWidth = true }) => {

    const [rect, setRect] = useState<DOMRect | null>(null);
    const menuRef = useRef<HTMLDivElement>(null);

    const updateRect = () => {
        if (!anchorEl) return;
        const r = anchorEl.getBoundingClientRect();
        setRect(r);
    };

    useLayoutEffect(() => {
        updateRect();
        const onScroll = () => updateRect();
        const onResize = () => updateRect();
        window.addEventListener("scroll", onScroll, true);
        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("scroll", onScroll, true);
            window.removeEventListener("resize", onResize);
        };
    }, [anchorEl]);

    if (!anchorEl || !rect) return null;

    const style: React.CSSProperties = {
        position: "fixed",
        left: rect.left,
        top: openAbove ? rect.top : rect.bottom,
        width: matchWidth ? rect.width : undefined,
        transform: openAbove ? "translateY(-100%)" : "translateY(0)",
        zIndex,
    };

    // react-select v1 closes its menu on any document touchstart outside its own wrapper.
    // This menu is portaled outside that wrapper, so on touch devices the first touch on an
    // option closed the menu before the tap could select it. Keep touches inside the menu.
    return ReactDOM.createPortal(
        <div ref={menuRef} style={style} onTouchStart={(e) => e.stopPropagation()}>
            {children}
        </div>,
        document.body
    );
};